import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const conversationsSettingsRoutes = [
  {
    path: 'conversations-settings',
    name: 'settings.conversations-setting',
    meta: {
      permissions: undefined,
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.conversations_setting_trans',
        route: { name: 'settings.conversations-setting' },
      }),
    },
    component: () => import('@/views/System/Settings/Conversations/ConversationsSettings.vue'),
  },
];

export default conversationsSettingsRoutes;
